import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { alpha } from "@mui/material/styles";

import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useTranslation } from "react-i18next";
import { formatDateForDisplay } from "../../utils/dateUtils";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import {
  Alert,
  Box,
  Badge,
  FormControl,
  TextField,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Tooltip,
  Radio,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Stack,
  TableContainer,
  Chip,
} from "@mui/material";
import ArticuloA3Dialog from "../Produccion/ArticuloA3Dialog";
import ProduccionPedidosDialog from "../Produccion/ProduccionPedidosDialog";
import { normalizeFechaIso } from "../Produccion/a3PedidoMatrizUtils";
import {
  createA3Pedidos,
  deleteA3Pedidos,
  getPresupuestoA3Pedidos,
  updateA3Pedidos,
} from "../../api/Produccion/a3ArticulosApi";
import { linkCriticalPathFromPedido } from "../../api/Estimates/estimatesApi";
import {
  getEmpresaA3Meta,
  normalizeEmpresaA3,
} from "../../constants/a3Empresas";
import { getLogisticaEnviosResumen } from "../../api/Logistica/logisticaEnviosApi";
import PedidoEnviosDialog from "../Produccion/PedidoEnviosDialog";
import PedidoCompraPrint from "../Produccion/PedidoCompraPrint";
import { getUserById } from "../../api/User/userApi";
import {
  A3_COL_COMPRA_WIDTH,
  A3_COL_LINK_ESTIMATES_WIDTH,
  A3_COL_VENTA_WIDTH,
  a3PedidosCellClipSx,
  a3PedidosTableContainerSx,
  a3PedidosTableFixedSx,
  a3TableDenseSx,
} from "../../constants/a3PedidosTableLayout";
import { computePrendasUnidadesPedido } from "../../utils/cpUnits";
import {
  a3PedidoRowReactKey,
  buildOptimisticA3PedidoRow,
  formatA3PartyLabel,
  nextReferenciaPedidoSuffix,
} from "../../utils/a3PedidosListUtils";
import {
  a3EstadoBadgeSx,
  etiquetaMonedaResumen,
  fmtA3Cantidad,
  fmtA3Estado,
  fmtA3Importe,
  fmtA3PorcIva,
  isA3Served,
  resolveUnitPriceStable,
  truncA3,
} from "../../utils/presupuestoDisplayUtils";
import EstimateComunicacionesPanel from "./EstimateComunicacionesPanel";
import EstimateImportA3PedidoDialog from "./EstimateImportA3PedidoDialog";
import { fetchBudgetLines } from "../../api/Estimates/budgetLinesApi";
import {
  buildImportA3PedidoGroups,
  buildImportReferencia,
  IMPORT_A3_CODART,
  isImportA3PedidoRow,
  shouldOfferImportA3Pedido,
} from "../../utils/importA3PedidoPure";

const CardDerechaBolas = ({
  theme,
  budget,
  newPresupuesto,
  setNewPresupuesto,
  isEstimatesLocked,
  setConfirmUnlockOpen,
  canUnlockEstimate = false,
  handleStateChange,
  handleStateChangeClick,
  API_URL,
  escandalloGrupos,
  escandalloSubgrupos,
  materialSubgrupos = [],
  lines,
  setLines,
  refreshKey,
  setRefreshKey,
  proveedores = [],
  formatNumber,
  calculateCostPriceUN,
  calculateTotalCost,
  calculateSellingPriceUN,
  calculateTotalSellingPrice,
  calculateMarginUn,
  calculateTotalMargin,
  calculateMarginPercentage,
  PriceChangeTwoToneIcon,
  EuroTwoToneIcon,
  ReceiptTwoToneIcon,
  BeachAccessIcon,
  EstimatesLineas,
}) => {
  const { t } = useTranslation();
  const statusLabel = (estado) =>
    ({
      Created: t("EstimatesPage.drawer.statusCreated"),
      Offered: t("EstimatesPage.drawer.statusOffered"),
      Cancelled: t("EstimatesPage.drawer.statusCancelled"),
      Accepted: t("EstimatesPage.drawer.statusAccepted"),
    })[estado] ||
    estado ||
    "";
  const [confirmCPDialogOpen, setConfirmCPDialogOpen] = useState(false);
  const [articuloDialogOpen, setArticuloDialogOpen] = useState(false);
  const [pedidosDialogOpen, setPedidosDialogOpen] = useState(false);
  const [selectedArticuloA3, setSelectedArticuloA3] = useState(null);
  const [summaryTab, setSummaryTab] = useState(0);
  const [a3PedidosRows, setA3PedidosRows] = useState([]);
  const [loadingA3Pedidos, setLoadingA3Pedidos] = useState(false);
  const [enviosCountByPedido, setEnviosCountByPedido] = useState({});
  const [pedidoCrmEditando, setPedidoCrmEditando] = useState(null);
  const [deleteA3DialogOpen, setDeleteA3DialogOpen] = useState(false);
  const [deleteA3DialogRow, setDeleteA3DialogRow] = useState(null);
  const [deleteA3DialogError, setDeleteA3DialogError] = useState("");
  const [deleteA3DialogLoading, setDeleteA3DialogLoading] = useState(false);
  const [unitsLimitDialogOpen, setUnitsLimitDialogOpen] = useState(false);
  const [unitsLimitDialogMessage, setUnitsLimitDialogMessage] = useState("");
  const [pendingOverUnitsCreate, setPendingOverUnitsCreate] = useState(null);
  const [enviosDialogRow, setEnviosDialogRow] = useState(null);
  const a3PedidosLoadSeqRef = useRef(0);
  const [postPedidoCpDialog, setPostPedidoCpDialog] = useState({
    open: false,
    idPresupuestoA3Pedido: null,
    unidadesPrendas: 0,
  });
  const [importA3Dialog, setImportA3Dialog] = useState({
    open: false,
    groups: [],
    referencia: "",
    dbSource: "STAGE_DESIGN",
    fecha: null,
    centroCosteEmpresa: "",
    centroCosteMarca: "",
    centroCosteDepartamento: "",
  });
  /** null = aún no cargado; true/false desde API (Users.Permiso_PedidosA3). */
  const [permisoPedidosA3, setPermisoPedidosA3] = useState(null);

  /** IdProyecto fiable: estado del drawer a veces solo trae IdProyectoCab en `budget`. */
  const proyectoIdEfectivo = useMemo(() => {
    const n = (v) => {
      const x = Number(v);
      return Number.isFinite(x) && x > 0 ? x : 0;
    };
    return (
      n(newPresupuesto?.ProyectoId) ||
      n(budget?.IdProyectoCab) ||
      n(newPresupuesto?.IdProyecto) ||
      0
    );
  }, [
    newPresupuesto?.ProyectoId,
    newPresupuesto?.IdProyecto,
    budget?.IdProyectoCab,
  ]);

  const canOpenA3PedidoFlow =
    Boolean(proyectoIdEfectivo) &&
    Boolean(budget?.IdPresupuesto) &&
    ["Offered", "Accepted"].includes(newPresupuesto?.Estado);

  const puedeCrearOEditarPedidoA3 = permisoPedidosA3 === true;

  useEffect(() => {
    const token = localStorage.getItem("token");
    let userId = null;
    if (token) {
      try {
        const decoded = jwtDecode(token);
        userId = decoded.userId;
      } catch {
        /* ignore */
      }
    }
    if (!userId) {
      setPermisoPedidosA3(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const user = await getUserById(userId);
        if (!cancelled) {
          setPermisoPedidosA3(Boolean(user?.Permiso_PedidosA3));
        }
      } catch (e) {
        console.error("Error cargando Permiso_PedidosA3:", e);
        if (!cancelled) setPermisoPedidosA3(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const loadA3Pedidos = useCallback(async () => {
    const pid = newPresupuesto?.IdPresupuesto;
    const proj = proyectoIdEfectivo;
    const loadSeq = ++a3PedidosLoadSeqRef.current;
    if (!pid || !proj) {
      setA3PedidosRows([]);
      setEnviosCountByPedido({});
      return;
    }
    setLoadingA3Pedidos(true);
    try {
      const [data, enviosResumen] = await Promise.all([
        getPresupuestoA3Pedidos(proj, pid),
        getLogisticaEnviosResumen({ limit: 2000 }).catch(() => ({ rows: [] })),
      ]);
      if (loadSeq !== a3PedidosLoadSeqRef.current) return;
      setA3PedidosRows(Array.isArray(data?.rows) ? data.rows : []);
      const enviosRows = Array.isArray(enviosResumen)
        ? enviosResumen
        : Array.isArray(enviosResumen?.rows)
          ? enviosResumen.rows
          : [];
      const byPedidoSets = new Map();
      for (const envio of enviosRows) {
        const idEnvio = Number(envio?.IdLogisticaEnvio);
        if (!Number.isFinite(idEnvio) || idEnvio <= 0) continue;
        const links = Array.isArray(envio?.pedidoLinks)
          ? envio.pedidoLinks
          : [];
        for (const lnk of links) {
          const idPed = Number(
            lnk?.IdPresupuestoA3Pedido ?? lnk?.pedidoA3?.IdPresupuestoA3Pedido,
          );
          if (!Number.isFinite(idPed) || idPed <= 0) continue;
          if (!byPedidoSets.has(idPed)) byPedidoSets.set(idPed, new Set());
          byPedidoSets.get(idPed).add(idEnvio);
        }
      }
      const counts = {};
      for (const [idPed, idsEnvio] of byPedidoSets.entries()) {
        counts[idPed] = idsEnvio.size;
      }
      setEnviosCountByPedido(counts);
    } catch (err) {
      if (loadSeq !== a3PedidosLoadSeqRef.current) return;
      console.error("Error cargando pedidos A3 del presupuesto:", err);
      setA3PedidosRows([]);
      setEnviosCountByPedido({});
    } finally {
      if (loadSeq === a3PedidosLoadSeqRef.current) {
        setLoadingA3Pedidos(false);
      }
    }
  }, [newPresupuesto?.IdPresupuesto, proyectoIdEfectivo]);

  const handleDeleteA3Pedido = useCallback(
    (row) => {
      if (!row || !puedeCrearOEditarPedidoA3) return;
      if (
        isA3Served(row?.EstadoCompra, row?.EstadoDetalleCompra) ||
        isA3Served(row?.EstadoVenta, row?.EstadoDetalleVenta)
      ) {
        return;
      }
      setDeleteA3DialogRow(row);
      setDeleteA3DialogError("");
      setDeleteA3DialogOpen(true);
    },
    [puedeCrearOEditarPedidoA3],
  );

  const confirmDeleteA3Pedido = useCallback(async () => {
    if (!deleteA3DialogRow) return;
    setDeleteA3DialogLoading(true);
    setDeleteA3DialogError("");
    try {
      await deleteA3Pedidos({
        idPresupuestoA3Pedido: deleteA3DialogRow.IdPresupuestoA3Pedido,
        idPedc: deleteA3DialogRow.IdPedc,
        idPedv: deleteA3DialogRow.IdPedv,
        idLinCompra: deleteA3DialogRow.IdLinCompra,
        idLinVenta: deleteA3DialogRow.IdLinVenta,
        codart: deleteA3DialogRow.CodArt,
        serieCompra: deleteA3DialogRow.SerieCompra,
        numDocCompra: deleteA3DialogRow.NumDocCompra,
        serieVenta: deleteA3DialogRow.SerieVenta,
        numDocVenta: deleteA3DialogRow.NumDocVenta,
        dbSource: String(deleteA3DialogRow.EmpresaA3 || "").trim() || undefined,
      });
      setDeleteA3DialogOpen(false);
      setDeleteA3DialogRow(null);
      await loadA3Pedidos();
    } catch (e) {
      setDeleteA3DialogError(
        e?.response?.data?.error ||
          e?.message ||
          "No se pudo eliminar el pedido A3.",
      );
    } finally {
      setDeleteA3DialogLoading(false);
    }
  }, [deleteA3DialogRow, loadA3Pedidos]);

  const closeDeleteA3Dialog = useCallback(() => {
    if (deleteA3DialogLoading) return;
    setDeleteA3DialogOpen(false);
    setDeleteA3DialogRow(null);
    setDeleteA3DialogError("");
  }, [deleteA3DialogLoading]);

  useEffect(() => {
    setA3PedidosRows([]);
    setEnviosCountByPedido({});
  }, [newPresupuesto?.IdPresupuesto, proyectoIdEfectivo]);

  useEffect(() => {
    loadA3Pedidos();
  }, [loadA3Pedidos, refreshKey]);

  const referenciaPedidoSuffix = useMemo(
    () => nextReferenciaPedidoSuffix(a3PedidosRows),
    [a3PedidosRows],
  );

  /** Suma de totales documento (compra/venta) en la lista cargada del presupuesto. */
  const totalesA3PedidosLista = useMemo(() => {
    let docCompra = 0;
    let docVenta = 0;
    let filasConCompra = 0;
    let filasConVenta = 0;
    for (const row of a3PedidosRows) {
      if (row?.IdPedc != null && Number(row.IdPedc) > 0) {
        filasConCompra += 1;
        const x = Number(row.TotalDocumentoCompra);
        if (Number.isFinite(x)) docCompra += x;
      }
      if (row?.IdPedv != null && Number(row.IdPedv) > 0) {
        filasConVenta += 1;
        const x = Number(row.TotalDocumentoVenta);
        if (Number.isFinite(x)) docVenta += x;
      }
    }
    return { docCompra, docVenta, filasConCompra, filasConVenta };
  }, [a3PedidosRows]);

  const pedidosVentaExistentes = useMemo(
    () =>
      (Array.isArray(a3PedidosRows) ? a3PedidosRows : []).filter(
        (row) => row?.IdPedv != null && Number(row.IdPedv) > 0,
      ),
    [a3PedidosRows],
  );
  const hasPedidoVentaExistente = pedidosVentaExistentes.length > 0;

  const preciosDraftPresupuesto = useMemo(() => {
    const n = (v) => {
      const x = Number(v);
      return Number.isFinite(x) ? x : null;
    };
    return {
      compra: n(calculateCostPriceUN?.()),
      venta: n(calculateSellingPriceUN?.()),
    };
  }, [
    lines,
    newPresupuesto?.Units,
    newPresupuesto?.CosteUN,
    newPresupuesto?.VentaUN,
    newPresupuesto?.MargenUN,
    newPresupuesto?.Margen,
    refreshKey,
  ]);

  const articuloDraftFromPresupuesto = useMemo(() => {
    const n = (v) => {
      const x = Number(v);
      return Number.isFinite(x) ? x : null;
    };
    const normalizeMon = (v, fallback) => {
      const s = String(v || "")
        .trim()
        .toUpperCase();
      if (s === "USD" || s === "DOLAR" || s === "DOLARES" || s === "$")
        return "USD";
      if (s === "EUR" || s === "EURO" || s === "€") return "EURO";
      return fallback;
    };
    const sanitizeCodartDesdeTexto = (text) => {
      const raw = String(text || "").trim();
      if (!raw) return "";
      const sinAcentos = raw.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      let s = sinAcentos
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
      if (s.length > 25) s = s.slice(0, 25);
      return s;
    };
    const priceCompra = preciosDraftPresupuesto.compra;
    const priceVenta = preciosDraftPresupuesto.venta;
    const descArticulo = String(
      newPresupuesto?.designCliente || newPresupuesto?.NombrePresupuesto || "",
    ).trim();
    let codArticuloPropuesto = sanitizeCodartDesdeTexto(descArticulo);
    if (!codArticuloPropuesto) {
      codArticuloPropuesto =
        sanitizeCodartDesdeTexto(newPresupuesto?.ABREVIATURA) ||
        String(newPresupuesto?.IdPresupuesto ?? "").trim();
    }
    const firstLine =
      Array.isArray(lines) && lines.length > 0 ? lines[0] : null;
    const monedaCosteFromLine = normalizeMon(firstLine?.MonedaCoste, undefined);
    const monedaVentaFromLine = normalizeMon(firstLine?.MonedaVenta, undefined);
    return {
      CODMON:
        monedaCosteFromLine ||
        normalizeMon(newPresupuesto?.MonedaCoste, "EURO"),
      PRCCOMPRA: priceCompra != null ? String(priceCompra) : "",
      CODMONCOM:
        monedaVentaFromLine || normalizeMon(newPresupuesto?.MonedaVenta, "USD"),
      PRCVENTA: priceVenta != null ? String(priceVenta) : "",
      ProveedorNombre: String(newPresupuesto?.Proveedor || "").trim(),
      DESCART: descArticulo,
      CODART: codArticuloPropuesto,
      CAR1: String(newPresupuesto?.ABREVIATURA || "").trim(),
      TALLAS: "T",
    };
  }, [
    newPresupuesto?.designCliente,
    newPresupuesto?.NombrePresupuesto,
    newPresupuesto?.ABREVIATURA,
    newPresupuesto?.IdPresupuesto,
    lines,
    newPresupuesto?.MonedaCoste,
    newPresupuesto?.MonedaVenta,
    newPresupuesto?.Proveedor,
    newPresupuesto?.ABREVIATURA,
    preciosDraftPresupuesto.compra,
    preciosDraftPresupuesto.venta,
  ]);

  const empresaA3InicialArticulo = useMemo(() => {
    const fromPedido = (Array.isArray(a3PedidosRows) ? a3PedidosRows : []).find(
      (r) => String(r?.EmpresaA3 || "").trim(),
    );
    if (fromPedido?.EmpresaA3) {
      return normalizeEmpresaA3(fromPedido.EmpresaA3);
    }
    return "STAGE_DESIGN";
  }, [a3PedidosRows]);
  const unitsResumenCabecera = useMemo(() => {
    const estimadas = Number(newPresupuesto?.Units || 0);
    const pedidas = (Array.isArray(a3PedidosRows) ? a3PedidosRows : []).reduce(
      (acc, row) => {
        if (isImportA3PedidoRow(row)) return acc;
        const uc = Number(row?.UnidadesCompra || 0);
        const uv = Number(row?.UnidadesVenta || 0);
        return acc + Math.max(uc, uv, 0);
      },
      0,
    );
    return { estimadas, pedidas };
  }, [newPresupuesto?.Units, a3PedidosRows]);

  const executeCreatePedido = useCallback(
    async (_pedidoPayload) => {
      const nombreCli = String(
        _pedidoPayload?.clienteNombre || _pedidoPayload?.cliente || "",
      ).trim();
      const wasNotAccepted = newPresupuesto.Estado !== "Accepted";
      const modoAlta = _pedidoPayload?.modo || "ambos";
      const soloVentaAlta = modoAlta === "venta";
      const soloCompraAlta = modoAlta === "compra";
      const payload = {
        idPresupuesto: Number(newPresupuesto.IdPresupuesto),
        idProyecto: proyectoIdEfectivo,
        modo: modoAlta,
        codart: String(
          _pedidoPayload?.articulo ||
            selectedArticuloA3?.CODART ||
            selectedArticuloA3?.REFERENCIA ||
            "",
        ).trim(),
        codpro: String(_pedidoPayload?.proveedor || "").trim(),
        codcli: String(_pedidoPayload?.cliente || "").trim(),
        clienteNombre: nombreCli,
        proveedorNombre: String(_pedidoPayload?.proveedorNombre || "").trim(),
        referencia: _pedidoPayload?.referencia,
        unidadesCompra: soloVentaAlta
          ? 0
          : Number(_pedidoPayload?.unidadesCompra || 0),
        precioCoste: soloVentaAlta
          ? 0
          : Number(String(_pedidoPayload?.precioCoste || 0).replace(",", ".")),
        codMonCompra: String(_pedidoPayload?.monedaCompra || "").trim(),
        unidadesVenta: soloCompraAlta
          ? 0
          : Number(_pedidoPayload?.unidadesVenta || 0),
        precioVenta: soloCompraAlta
          ? 0
          : Number(String(_pedidoPayload?.precioVenta || 0).replace(",", ".")),
        codMonVenta: String(_pedidoPayload?.monedaVenta || "").trim(),
        tipoContable: String(_pedidoPayload?.tipoContable || "1").trim(),
        dbSource: String(_pedidoPayload?.dbSource || "STAGE_DESIGN").trim(),
        lineasTallas: Array.isArray(_pedidoPayload?.lineasTallas)
          ? _pedidoPayload.lineasTallas
          : [],
        lineasConcepto: Array.isArray(_pedidoPayload?.lineasConcepto)
          ? _pedidoPayload.lineasConcepto
          : undefined,
        fecha: normalizeFechaIso(_pedidoPayload?.fecha),
        centroCosteEmpresa: String(
          _pedidoPayload?.centroCosteEmpresa || "",
        ).trim(),
        centroCosteMarca: String(_pedidoPayload?.centroCosteMarca || "").trim(),
        centroCosteDepartamento: String(
          _pedidoPayload?.centroCosteDepartamento || "",
        ).trim(),
      };
      const resultado = await createA3Pedidos(payload);
      if (resultado?.crmLink && !resultado.crmLink.persisted) {
        console.warn(
          "Pedido creado en A3 pero no se guardó el vínculo en CRM:",
          resultado.crmLink,
        );
      }
      const optimisticRow = buildOptimisticA3PedidoRow(payload, resultado);
      if (optimisticRow) {
        setA3PedidosRows((prev) => {
          const id = Number(optimisticRow.IdPresupuestoA3Pedido);
          const rest = (Array.isArray(prev) ? prev : []).filter(
            (r) => Number(r?.IdPresupuestoA3Pedido) !== id,
          );
          return [optimisticRow, ...rest];
        });
      }
      const productIdCp =
        Number(newPresupuesto.ProductId) ||
        Number(newPresupuesto.IdProducto) ||
        null;
      const crmId = resultado?.crmLink?.crmId;
      const unidadesPrendas = computePrendasUnidadesPedido(
        _pedidoPayload,
        modoAlta,
      );
      if (wasNotAccepted) {
        await handleStateChangeClick("Accepted");
      }
      await loadA3Pedidos();
      if (
        crmId &&
        productIdCp &&
        unidadesPrendas > 0 &&
        modoAlta !== "compra"
      ) {
        setPostPedidoCpDialog({
          open: true,
          idPresupuestoA3Pedido: crmId,
          unidadesPrendas,
        });
      }

      const isImportPayload =
        String(payload.codart || "").trim() === IMPORT_A3_CODART ||
        (Array.isArray(_pedidoPayload?.lineasConcepto) &&
          _pedidoPayload.lineasConcepto.length > 0);
      if (!isImportPayload && (modoAlta === "ambos" || modoAlta === "compra")) {
        const refImp = buildImportReferencia(payload.referencia);
        const rowsForIdempotency = optimisticRow
          ? [
              optimisticRow,
              ...(Array.isArray(a3PedidosRows) ? a3PedidosRows : []),
            ]
          : a3PedidosRows;
        const offer = shouldOfferImportA3Pedido({
          idIncoterm: newPresupuesto?.Id_Incoterm,
          lines,
          a3PedidosRows: rowsForIdempotency,
          referenciaImp: refImp,
        });
        const { groups } = buildImportA3PedidoGroups(
          lines,
          escandalloSubgrupos,
          proveedores,
        );
        if (offer && groups.length > 0) {
          setImportA3Dialog({
            open: true,
            groups,
            referencia: refImp,
            dbSource: payload.dbSource,
            fecha: payload.fecha || null,
            centroCosteEmpresa: payload.centroCosteEmpresa || "",
            centroCosteMarca: payload.centroCosteMarca || "",
            centroCosteDepartamento: payload.centroCosteDepartamento || "",
          });
        }
      }

      setPedidosDialogOpen(false);
      setPedidoCrmEditando(null);
      setSummaryTab(1);
    },
    [
      newPresupuesto,
      proyectoIdEfectivo,
      selectedArticuloA3,
      handleStateChangeClick,
      loadA3Pedidos,
      lines,
      escandalloSubgrupos,
      proveedores,
      a3PedidosRows,
    ],
  );

  const handleUnitsChange = async (e) => {
    if (isEstimatesLocked) return;

    // Normaliza (el input está formateado con . de miles)
    const rawValue = e.target.value.replace(/\./g, "");
    const unitsValue = parseInt(rawValue, 10) || 0;

    // 1) Actualiza estado local
    setNewPresupuesto((prev) => ({
      ...prev,
      Units: unitsValue,
    }));

    // 2) Persiste en backend
    if (newPresupuesto.IdPresupuesto) {
      try {
        await axios.put(
          `${API_URL}/api/proyectos/${proyectoIdEfectivo || newPresupuesto.ProyectoId}/presupuestos/${newPresupuesto.IdPresupuesto}`,
          { ...newPresupuesto, Units: unitsValue },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
      } catch (error) {
        console.error("Error al guardar Units automáticamente:", error);
      }
    }

    // ⚠️ Importante:
    // Ya NO tocamos aquí las líneas 203/204/198 (per CBM) para evitar
    // duplicar efecto (las Totales ya multiplican por Units cuando procede).
    // Si cambias VOL, los recálculos internos los hace EstimatesLineas.
  };

  return (
    <Box
      sx={{
        background: "transparent",
        display: "flex",
        justifyContent: "flex-star",
        flexDirection: "column",
        minWidth: 0,
        width: "100%",
        maxWidth: "100%",
        overflow: "visible",
      }}
    >
      {budget?.IdPresupuesto && (
        <CardContent
          sx={{
            backgroundColor: theme.palette.background.default,
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",

            padding: {
              xs: "16px 14px 18px 14px !important",
              md: "18px 18px 20px 18px !important",
              xl: "20px 22px 22px 24px !important",
            },
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
            gap: 1.5,
          }}
        >
          <Box
            sx={{
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "column",
              gap: 1.1,
              pb: 0.9,
              /* backgroundColor: theme.palette.background.paper, */
              /* borderBottom: `1px solid ${alpha(theme.palette.divider, 0.12)}`, */
            }}
          >
            {/* CABECERA / BOLAS */}
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 1.5,
                p: { xs: 1.25, md: 1.5 },
                borderRadius: 3,
                border: "1px solid",
                borderColor: alpha(theme.palette.primary.main, 0.18),
                backgroundColor: theme.palette.background.paper,
                boxShadow: `0 10px 28px ${alpha(theme.palette.common.black, 0.07)}`,
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="overline"
                  sx={{
                    color: "text.secondary",
                    display: "block",
                    fontWeight: 800,
                    letterSpacing: 0.9,
                  }}
                >
                  {t("EstimatesPage.drawer.workspace")}
                </Typography>
                <Typography
                  sx={{
                    color: "primary.dark",
                    fontSize: { xs: "1.3rem", md: "1.55rem" },
                    fontWeight: 900,
                    lineHeight: 1.15,
                  }}
                >
                  {t("EstimatesPage.drawer.summary")}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: { xs: "flex-start", md: "flex-end" },
                  gap: 0.75,
                }}
              >
                <Chip
                  size="small"
                  label={statusLabel(newPresupuesto?.Estado) || t("EstimatesPage.drawer.statusCreated")}
                  sx={{
                    fontWeight: 800,
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                    color: "primary.main",
                  }}
                />
                <Chip
                  size="small"
                  label={`Units ${fmtA3Cantidad(newPresupuesto?.Units || 0)}`}
                  sx={{
                    fontWeight: 800,
                    bgcolor: alpha("#00c2a3", 0.12),
                    color: "#00a58a",
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.25,
                    px: 0.75,
                    py: 0.35,
                    borderRadius: 999,
                    bgcolor: alpha(theme.palette.common.white, 0.7),
                    border: "1px solid",
                    borderColor: alpha(theme.palette.primary.main, 0.12),
                  }}
                >
                  {/* bolas */}
                  <Box>
                    {/* Created */}
                    <Tooltip
                      title={
                        <>
                          {statusLabel("Created")}
                          <br />
                          {newPresupuesto.FechaCrear || t("EstimatesPage.drawer.noDate")}
                        </>
                      }
                      arrow
                    >
                      <Box display="inline-block">
                        <Radio
                          checked={newPresupuesto.Estado === "Created"}
                          onChange={() => handleStateChange("Created")}
                          disabled={
                            newPresupuesto.Estado === "Offered" ||
                            newPresupuesto.Estado === "Cancelled" ||
                            newPresupuesto.Estado === "Accepted"
                          }
                          icon={
                            <Box
                              sx={{
                                width: 18,
                                height: 18,
                                border: "3px solid #c896ff",
                                borderRadius: "50%",
                                backgroundColor:
                                  theme.palette.mode === "dark"
                                    ? theme.palette.background.cajaInpunts
                                    : "#fff",
                              }}
                            />
                          }
                          checkedIcon={
                            <Box
                              sx={{
                                width: 18,
                                height: 18,
                                border: "3px solid #c896ff",
                                borderRadius: "50%",
                                backgroundColor: "#00c2a39c",
                              }}
                            />
                          }
                          sx={{ mr: 1, padding: 0 }}
                        />
                      </Box>
                    </Tooltip>

                    {/* Offered */}
                    <Tooltip
                      title={
                        <>
                          {statusLabel("Offered")}
                          <br />
                          {newPresupuesto.FechaPresentacion || t("EstimatesPage.drawer.noDate")}
                        </>
                      }
                      arrow
                    >
                      <Box display="inline-block">
                        <Radio
                          checked={newPresupuesto.Estado === "Offered"}
                          onChange={() => handleStateChangeClick("Offered")}
                          disabled={
                            newPresupuesto.Estado === "Cancelled" ||
                            newPresupuesto.Estado === "Accepted"
                          }
                          icon={
                            <Box
                              sx={{
                                width: 18,
                                height: 18,
                                border: "3px solid #34afc7",
                                borderRadius: "50%",
                                backgroundColor:
                                  theme.palette.mode === "dark"
                                    ? theme.palette.background.cajaInpunts
                                    : "#fff",
                              }}
                            />
                          }
                          checkedIcon={
                            <Box
                              sx={{
                                width: 18,
                                height: 18,
                                border: "3px solid #c896ff",
                                borderRadius: "50%",
                                backgroundColor: "#00c2a39c",
                              }}
                            />
                          }
                          sx={{ mr: 1, padding: 0 }}
                        />
                      </Box>
                    </Tooltip>

                    {/* Cancelled */}
                    <Tooltip
                      title={
                        <>
                          {statusLabel("Cancelled")}
                          <br />
                          {newPresupuesto.FechaCancelacion || t("EstimatesPage.drawer.noDate")}
                        </>
                      }
                      arrow
                    >
                      <Box display="inline-block">
                        <Radio
                          checked={newPresupuesto.Estado === "Cancelled"}
                          onChange={() => handleStateChangeClick("Cancelled")}
                          disabled={
                            newPresupuesto.Estado === "Cancelled" ||
                            newPresupuesto.Estado === "Accepted"
                          }
                          icon={
                            <Box
                              sx={{
                                width: 18,
                                height: 18,
                                border: "3px solid #f44336",
                                borderRadius: "50%",
                                backgroundColor:
                                  theme.palette.mode === "dark"
                                    ? theme.palette.background.cajaInpunts
                                    : "#fff",
                              }}
                            />
                          }
                          checkedIcon={
                            <Box
                              sx={{
                                width: 18,
                                height: 18,
                                border: "3px solid #c896ff",
                                borderRadius: "50%",
                                backgroundColor: "#00c2a39c",
                              }}
                            />
                          }
                          sx={{ mr: 1, padding: 0 }}
                        />
                      </Box>
                    </Tooltip>

                    {/* Accepted */}
                    <Tooltip
                      title={
                        <>
                          {statusLabel("Accepted")}
                          <br />
                          {newPresupuesto.FechaAceptacion || t("EstimatesPage.drawer.noDate")}
                        </>
                      }
                      arrow
                    >
                      <Box display="inline-block">
                        <Radio
                          checked={newPresupuesto.Estado === "Accepted"}
                          onChange={() => {
                            setConfirmCPDialogOpen(true);
                          }}
                          disabled={newPresupuesto.Estado === "Accepted"}
                          icon={
                            <Box
                              sx={{
                                width: 18,
                                height: 18,
                                border: "3px solid #00c2a3",
                                borderRadius: "50%",
                                backgroundColor:
                                  theme.palette.mode === "dark"
                                    ? theme.palette.background.cajaInpunts
                                    : "#fff",
                              }}
                            />
                          }
                          checkedIcon={
                            <Box
                              sx={{
                                width: 18,
                                height: 18,
                                border: "3px solid #00c2a3",
                                borderRadius: "50%",
                                backgroundColor: "#00c2a39c",
                              }}
                            />
                          }
                          sx={{ padding: 0 }}
                        />
                      </Box>
                    </Tooltip>
                  </Box>

                  {/* Lápiz para desbloquear */}
                  {isEstimatesLocked && canUnlockEstimate && (
                    <Tooltip title={t("EstimatesPage.drawer.unlockTooltip")}>
                      <IconButton
                        onClick={() => setConfirmUnlockOpen(true)}
                        sx={{
                          color: "#c896ff",
                          marginLeft: "8px",
                          "&:hover": { color: "#00c2a3" },
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              </Box>
            </Box>

            <Dialog
              open={confirmCPDialogOpen}
              onClose={() => setConfirmCPDialogOpen(false)}
            >
              <DialogTitle>{t("EstimatesPage.drawer.acceptTitle")}</DialogTitle>

              <DialogContent>
                <DialogContentText>
                  {t("EstimatesPage.drawer.acceptIntro")}
                  {puedeCrearOEditarPedidoA3 && hasPedidoVentaExistente ? (
                    <>
                      <br />
                      <br />
                      {t("EstimatesPage.drawer.acceptExisting", {
                        count: pedidosVentaExistentes.length,
                      })}
                    </>
                  ) : (
                    <>
                      <br />
                      <br />
                      {t("EstimatesPage.drawer.acceptNoAutoCp")}
                      {puedeCrearOEditarPedidoA3 ? (
                        <>
                          <br />
                          <br />
                          {t("EstimatesPage.drawer.acceptThenLink")}
                        </>
                      ) : null}
                    </>
                  )}
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={() => setConfirmCPDialogOpen(false)}
                  color="inherit"
                  sx={{
                    fontWeight: 700,
                    color: "#ff0000",

                    "&:hover": {
                      backgroundColor: "#ff0000",
                      color: "#ffffff",
                    },
                  }}
                >
                  {t("EstimatesPage.cancel")}
                </Button>

                <Button
                  onClick={async () => {
                    try {
                      if (
                        puedeCrearOEditarPedidoA3 &&
                        !hasPedidoVentaExistente
                      ) {
                        setArticuloDialogOpen(true);
                      } else {
                        await handleStateChangeClick("Accepted");
                        if (hasPedidoVentaExistente) {
                          setSummaryTab(1);
                        }
                      }
                    } catch (err) {
                      console.error("❌ Error al aceptar presupuesto:", err);
                    } finally {
                      setConfirmCPDialogOpen(false);
                    }
                  }}
                  sx={{
                    fontWeight: 700,
                    color: "#fff",
                    backgroundColor: "#00c2a3",
                    "&:hover": {
                      backgroundColor: "rgba(101, 167, 40, 0.2)",
                      color: "#00c2a3",
                    },
                  }}
                  autoFocus
                >
                  {t("EstimatesPage.drawer.confirm")}
                </Button>
              </DialogActions>
            </Dialog>
            <ArticuloA3Dialog
              open={articuloDialogOpen}
              onClose={() => setArticuloDialogOpen(false)}
              initialDbSource={empresaA3InicialArticulo}
              suggestedCode={
                articuloDraftFromPresupuesto?.CODART ||
                newPresupuesto?.ABREVIATURA ||
                newPresupuesto?.designCliente ||
                String(newPresupuesto?.IdPresupuesto || "")
              }
              initialDraft={articuloDraftFromPresupuesto}
              onResolved={async (articulo) => {
                try {
                  setPedidoCrmEditando(null);
                  setSelectedArticuloA3(
                    articulo
                      ? {
                          ...articulo,
                          dbSource: normalizeEmpresaA3(
                            articulo?.dbSource,
                            empresaA3InicialArticulo,
                          ),
                        }
                      : null,
                  );
                  setPedidosDialogOpen(true);
                } catch (err) {
                  console.error("❌ Error aceptando presupuesto:", err);
                } finally {
                  setArticuloDialogOpen(false);
                }
              }}
            />
            <ProduccionPedidosDialog
              open={pedidosDialogOpen}
              onClose={() => {
                setPedidosDialogOpen(false);
                setPedidoCrmEditando(null);
              }}
              articulo={
                pedidoCrmEditando
                  ? {
                      CODART: pedidoCrmEditando.CodArt,
                      CODPRO: pedidoCrmEditando.CodPro,
                      CODFAMTALLAH:
                        pedidoCrmEditando.CodFamTallaH ??
                        pedidoCrmEditando.CODFAMTALLAH ??
                        "",
                      CODFAMTALLAV:
                        pedidoCrmEditando.CodFamTallaV ??
                        pedidoCrmEditando.CODFAMTALLAV ??
                        "",
                    }
                  : selectedArticuloA3
              }
              presupuesto={newPresupuesto}
              pedidosContextRows={a3PedidosRows}
              registroCrm={pedidoCrmEditando}
              initialDbSource={
                String(
                  pedidoCrmEditando?.EmpresaA3 ||
                    selectedArticuloA3?.dbSource ||
                    "STAGE_DESIGN",
                ).trim() || "STAGE_DESIGN"
              }
              lockDbSource={!pedidoCrmEditando}
              referenciaSuffix={referenciaPedidoSuffix}
              clienteNombre={
                budget?.ClienteNombre ||
                budget?.NombreCliente ||
                budget?.Cliente ||
                ""
              }
              onConfirm={async (_pedidoPayload, { isEdit } = {}) => {
                const nombreCli = String(
                  _pedidoPayload?.clienteNombre ||
                    _pedidoPayload?.cliente ||
                    "",
                ).trim();
                // Guardrail temporalmente desactivado en esta vista:
                // el cálculo de acumulados entre modos/filas estaba bloqueando ediciones válidas.

                if (isEdit && pedidoCrmEditando) {
                  if (!puedeCrearOEditarPedidoA3) return;
                  const tienePedc = Boolean(pedidoCrmEditando?.IdPedc);
                  const tienePedv = Boolean(pedidoCrmEditando?.IdPedv);
                  const payloadUpd = {
                    idPresupuestoA3Pedido:
                      pedidoCrmEditando.IdPresupuestoA3Pedido,
                    idPresupuesto: Number(newPresupuesto.IdPresupuesto),
                    idProyecto: proyectoIdEfectivo,
                    idPedc: pedidoCrmEditando.IdPedc,
                    idPedv: pedidoCrmEditando.IdPedv,
                    idLinCompra: pedidoCrmEditando.IdLinCompra,
                    idLinVenta: pedidoCrmEditando.IdLinVenta,
                    codart: String(_pedidoPayload?.articulo || "").trim(),
                    codpro: String(_pedidoPayload?.proveedor || "").trim(),
                    codcli: String(_pedidoPayload?.cliente || "").trim(),
                    clienteNombre: nombreCli,
                    proveedorNombre: String(
                      _pedidoPayload?.proveedorNombre || "",
                    ).trim(),
                    referencia: _pedidoPayload?.referencia,
                    unidadesCompra: tienePedc
                      ? Number(_pedidoPayload?.unidadesCompra || 0)
                      : 0,
                    precioCoste: tienePedc
                      ? Number(
                          String(_pedidoPayload?.precioCoste || 0).replace(
                            ",",
                            ".",
                          ),
                        )
                      : 0,
                    codMonCompra: String(
                      _pedidoPayload?.monedaCompra || "",
                    ).trim(),
                    unidadesVenta: tienePedv
                      ? Number(_pedidoPayload?.unidadesVenta || 0)
                      : 0,
                    precioVenta: tienePedv
                      ? Number(
                          String(_pedidoPayload?.precioVenta || 0).replace(
                            ",",
                            ".",
                          ),
                        )
                      : 0,
                    codMonVenta: String(
                      _pedidoPayload?.monedaVenta || "",
                    ).trim(),
                    fecha: normalizeFechaIso(_pedidoPayload?.fecha),
                    fechaCompra: normalizeFechaIso(_pedidoPayload?.fechaCompra),
                    fechaVenta: normalizeFechaIso(_pedidoPayload?.fechaVenta),
                    lineasTallas: Array.isArray(_pedidoPayload?.lineasTallas)
                      ? _pedidoPayload.lineasTallas
                      : [],
                    centroCosteEmpresa: String(
                      _pedidoPayload?.centroCosteEmpresa || "",
                    ).trim(),
                    centroCosteMarca: String(
                      _pedidoPayload?.centroCosteMarca || "",
                    ).trim(),
                    centroCosteDepartamento: String(
                      _pedidoPayload?.centroCosteDepartamento || "",
                    ).trim(),
                    dbSource: String(
                      _pedidoPayload?.dbSource ||
                        pedidoCrmEditando?.EmpresaA3 ||
                        "STAGE_DESIGN",
                    ).trim(),
                  };
                  const resultadoUpd = await updateA3Pedidos(payloadUpd);
                  if (
                    resultadoUpd?.crmLink &&
                    !resultadoUpd.crmLink.updated &&
                    resultadoUpd.crmLink.error
                  ) {
                    console.warn(
                      "Pedido actualizado en A3 pero falló la métrica en CRM:",
                      resultadoUpd.crmLink,
                    );
                  }
                  await loadA3Pedidos();
                  setPedidosDialogOpen(false);
                  setPedidoCrmEditando(null);
                  setSummaryTab(1);
                  return;
                }
                const codartPayload = String(
                  _pedidoPayload?.articulo ||
                    selectedArticuloA3?.CODART ||
                    selectedArticuloA3?.REFERENCIA ||
                    "",
                )
                  .trim()
                  .toUpperCase();
                const unitsPresupuesto = Number(newPresupuesto?.Units || 0);
                const tipoContableObjetivo = String(
                  _pedidoPayload?.tipoContable || "1",
                ).trim();
                const unidadesExistentes = (
                  Array.isArray(a3PedidosRows) ? a3PedidosRows : []
                )
                  .filter(
                    (row) =>
                      String(row?.CodArt || "")
                        .trim()
                        .toUpperCase() === codartPayload &&
                      String(
                        row?.TipoContableVenta ??
                          row?.TipoContableCompra ??
                          "1",
                      ).trim() === tipoContableObjetivo,
                  )
                  .reduce((acc, row) => {
                    const uc = Number(row?.UnidadesCompra || 0);
                    const uv = Number(row?.UnidadesVenta || 0);
                    return acc + Math.max(uc, uv, 0);
                  }, 0);
                const incomingCompra = Number(
                  _pedidoPayload?.unidadesCompra || 0,
                );
                const incomingVenta = Number(
                  _pedidoPayload?.unidadesVenta || 0,
                );
                const modoAlta = String(_pedidoPayload?.modo || "ambos")
                  .trim()
                  .toLowerCase();
                const incomingUnits =
                  modoAlta === "compra"
                    ? Math.max(incomingCompra, 0)
                    : modoAlta === "venta"
                      ? Math.max(incomingVenta, 0)
                      : Math.max(incomingCompra, incomingVenta, 0);
                const totalTrasGuardar = unidadesExistentes + incomingUnits;
                if (
                  unitsPresupuesto > 0 &&
                  totalTrasGuardar - unitsPresupuesto > 0.0001
                ) {
                  setUnitsLimitDialogMessage(
                    `El total acumulado del artículo ${codartPayload} (tipo ${tipoContableObjetivo}) sería ${totalTrasGuardar}, por encima de Units (${unitsPresupuesto}). ¿Quieres continuar y crear el pedido igualmente?`,
                  );
                  setPendingOverUnitsCreate(_pedidoPayload);
                  setUnitsLimitDialogOpen(true);
                  return;
                }
                await executeCreatePedido(_pedidoPayload);
              }}
            />

            <Dialog
              open={postPedidoCpDialog.open}
              onClose={() =>
                setPostPedidoCpDialog((p) => ({ ...p, open: false }))
              }
            >
              <DialogTitle>Añadir al Critical Path</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  ¿Quieres vincular este pedido de venta al Critical Path con{" "}
                  <strong>
                    {fmtA3Cantidad(postPedidoCpDialog.unidadesPrendas)}
                  </strong>{" "}
                  prendas?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() =>
                    setPostPedidoCpDialog((p) => ({ ...p, open: false }))
                  }
                >
                  No
                </Button>
                <Button
                  variant="contained"
                  onClick={async () => {
                    try {
                      const pid =
                        Number(newPresupuesto.ProductId) ||
                        Number(newPresupuesto.IdProducto) ||
                        null;
                      await linkCriticalPathFromPedido({
                        productId: pid,
                        idPresupuestoA3Pedido:
                          postPedidoCpDialog.idPresupuestoA3Pedido,
                        unidadesPrendasPedido:
                          postPedidoCpDialog.unidadesPrendas,
                      });
                    } catch (err) {
                      console.error("❌ Error vinculando CP:", err);
                    } finally {
                      setPostPedidoCpDialog((p) => ({ ...p, open: false }));
                    }
                  }}
                >
                  Sí, añadir
                </Button>
              </DialogActions>
            </Dialog>

            <EstimateImportA3PedidoDialog
              open={importA3Dialog.open}
              onClose={() => setImportA3Dialog((p) => ({ ...p, open: false }))}
              groups={importA3Dialog.groups}
              referenciaInicial={importA3Dialog.referencia}
              dbSource={importA3Dialog.dbSource}
              idPresupuesto={Number(newPresupuesto.IdPresupuesto)}
              idProyecto={proyectoIdEfectivo}
              fecha={importA3Dialog.fecha}
              centroCosteEmpresa={importA3Dialog.centroCosteEmpresa}
              centroCosteMarca={importA3Dialog.centroCosteMarca}
              centroCosteDepartamento={importA3Dialog.centroCosteDepartamento}
              onCreated={async () => {
                await loadA3Pedidos();
                setSummaryTab(1);
              }}
            />

            <PedidoEnviosDialog
              open={Boolean(enviosDialogRow)}
              onClose={() => setEnviosDialogRow(null)}
              productId={
                Number(newPresupuesto.ProductId) ||
                Number(newPresupuesto.IdProducto) ||
                null
              }
              pedidoRow={enviosDialogRow}
              presupuesto={newPresupuesto}
              onChanged={loadA3Pedidos}
            />

            <Tabs
              value={summaryTab}
              onChange={(_, v) => setSummaryTab(v)}
              sx={{
                minHeight: 44,
                px: 0.5,
                py: 0.5,
                borderRadius: 999,
                alignSelf: "flex-start",
                backgroundColor: alpha(theme.palette.primary.main, 0.05),
                border: "1px solid",
                borderColor: alpha(theme.palette.primary.main, 0.08),
                "& .MuiTabs-indicator": { display: "none" },
                "& .MuiTab-root": {
                  minHeight: 34,
                  py: 0.5,
                  px: 1.5,
                  fontWeight: 800,
                  borderRadius: 999,
                  textTransform: "none",
                  color: "text.secondary",
                  transition: "all 0.2s ease",
                },
                "& .Mui-selected": {
                  color: "primary.main !important",
                  bgcolor: alpha(theme.palette.common.white, 0.96),
                  boxShadow: `0 8px 20px ${alpha(theme.palette.primary.main, 0.12)}`,
                },
              }}
            >
              <Tab label="Resumen" />
              <Tab
                label={
                  a3PedidosRows.length
                    ? `Pedidos A3 (${a3PedidosRows.length})`
                    : "Pedidos A3"
                }
              />
              <Tab
                icon={
                  <Badge
                    badgeContent={
                      Number(newPresupuesto?.CommCount) > 1
                        ? Number(newPresupuesto.CommCount)
                        : Number(newPresupuesto?.OpenRfqCount) > 0
                          ? Number(newPresupuesto.OpenRfqCount)
                          : 0
                    }
                    color={
                      Number(newPresupuesto?.OpenRfqCount) > 0
                        ? "warning"
                        : "primary"
                    }
                    overlap="circular"
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "0.65rem",
                        minWidth: 14,
                        height: 14,
                        top: 2,
                        right: 2,
                      },
                    }}
                  >
                    <MailOutlineIcon sx={{ fontSize: 18 }} />
                  </Badge>
                }
                iconPosition="start"
                label="Email Proveedores"
              />
              <Tab
                icon={
                  <Badge
                    badgeContent={
                      Number(newPresupuesto?.ClientOfferCount) > 0
                        ? Number(newPresupuesto.ClientOfferCount)
                        : 0
                    }
                    color="success"
                    overlap="circular"
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "0.65rem",
                        minWidth: 14,
                        height: 14,
                        top: 2,
                        right: 2,
                      },
                    }}
                  >
                    <MailOutlineIcon sx={{ fontSize: 18, color: "#00c2a3" }} />
                  </Badge>
                }
                iconPosition="start"
                label="Email a Clientes"
              />
            </Tabs>
          </Box>

          {summaryTab === 0 ? (
            <List
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "repeat(2, minmax(0, 1fr))",
                  sm: "repeat(2, minmax(0, 1fr))",
                  lg: "repeat(3, minmax(0, 1fr))",
                  xl: "minmax(110px, 0.58fr) minmax(110px, 0.58fr) repeat(4, minmax(0, 1fr))",
                },
                width: "100%",
                background: "transparent",
                alignItems: "stretch",
                gap: { xs: 1, md: 1.25 },
                py: 0.5,
              }}
            >
              <TextField
                label="Units"
                type="text"
                value={newPresupuesto.Units.toLocaleString("es-ES")}
                onChange={handleUnitsChange}
                sx={{
                  minWidth: 0,
                  width: "100%",
                  "& .MuiInputBase-root": {
                    minHeight: 66,
                    textAlign: "right",
                    color: "#34afc7",
                    fontSize: "1rem",
                    fontWeight: 800,
                  },
                  "& .MuiInputLabel-root": {
                    fontWeight: 700,
                  },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2.5,
                    backgroundColor: alpha(theme.palette.common.white, 0.96),
                    boxShadow: `0 12px 24px ${alpha(theme.palette.common.black, 0.06)}`,
                  },
                  "& .MuiInputBase-input": { textAlign: "right" },
                }}
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                disabled={isEstimatesLocked}
              />

              {/* Total m3 */}
              <FormControl sx={{ minWidth: 0, width: "100%" }}>
                <TextField
                  label="Total m³"
                  value={
                    newPresupuesto.VOL && newPresupuesto.Units
                      ? (
                          parseFloat(newPresupuesto.VOL) *
                          parseInt(newPresupuesto.Units)
                        ).toFixed(3)
                      : ""
                  }
                  InputProps={{ readOnly: true }}
                  sx={{
                    "& .MuiInputBase-root": {
                      minHeight: 66,
                      textAlign: "right",
                      color: "#34afc7",
                      fontSize: "1rem",
                      fontWeight: 800,
                    },
                    "& .MuiInputLabel-root": {
                      fontWeight: 700,
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2.5,
                      backgroundColor: alpha(theme.palette.common.white, 0.96),
                      boxShadow: `0 12px 24px ${alpha(theme.palette.common.black, 0.06)}`,
                    },
                    "& .MuiInputBase-input": { textAlign: "right" },
                  }}
                />
              </FormControl>

              {/* Coste */}
              <ListItem
                sx={{
                  width: "100%",
                  minWidth: 0,
                  gridColumn: { xs: "1 / -1", sm: "auto" },
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: alpha(theme.palette.error.main, 0.28),
                  backgroundColor: alpha(theme.palette.error.main, 0.08),
                  px: 1.25,
                  py: 1,
                  gap: 1,
                }}
              >
                <ListItemText
                  sx={{ my: 0, minWidth: 0 }}
                  primary={
                    <Typography sx={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontWeight: 800,
                          fontSize: "14px",
                          color: "#f44336",
                        }}
                      >
                        {formatNumber(calculateCostPriceUN())} |{" "}
                      </span>
                      <span>U</span>
                    </Typography>
                  }
                  secondary={
                    <Typography sx={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontWeight: 800,
                          fontSize: "14px",
                          color: "#f44336",
                        }}
                      >
                        {formatNumber(calculateTotalCost())} |{" "}
                      </span>
                      <span>T</span>
                    </Typography>
                  }
                />
                <ListItemAvatar
                  sx={{
                    ml: 1,
                    "& .MuiAvatar-root": { border: "1px solid #ffac7e" },
                  }}
                >
                  <Avatar
                    sx={{
                      color: "#ffac7e",
                      fontWeight: 600,
                      backgroundColor: theme.palette.background.paper,
                    }}
                  >
                    <Tooltip title="Cost price">
                      <PriceChangeTwoToneIcon />
                    </Tooltip>
                  </Avatar>
                </ListItemAvatar>
              </ListItem>

              {/* Venta */}
              <ListItem
                sx={{
                  width: "100%",
                  minWidth: 0,
                  gridColumn: { xs: "1 / -1", sm: "auto" },
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: alpha(theme.palette.primary.main, 0.28),
                  backgroundColor: alpha(theme.palette.primary.main, 0.08),
                  px: 1.25,
                  py: 1,
                  gap: 1,
                }}
              >
                <ListItemText
                  sx={{ my: 0, minWidth: 0 }}
                  primary={
                    <Typography sx={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontWeight: 800,
                          fontSize: "14px",
                          color: "#00c2a3",
                        }}
                      >
                        {formatNumber(calculateSellingPriceUN())} |{" "}
                      </span>
                      <span>U</span>
                    </Typography>
                  }
                  secondary={
                    <Typography sx={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontWeight: 800,
                          fontSize: "14px",
                          color: "#00c2a3",
                        }}
                      >
                        {formatNumber(calculateTotalSellingPrice())} |{" "}
                      </span>
                      <span>T</span>
                    </Typography>
                  }
                />
                <ListItemAvatar
                  sx={{
                    ml: 3,
                    "& .MuiAvatar-root": { border: "1px solid #00c2a3" },
                  }}
                >
                  <Avatar
                    sx={{
                      color: "#00c2a3",
                      fontWeight: 800,
                      backgroundColor: theme.palette.background.paper,
                    }}
                  >
                    <Tooltip title="Selling price">
                      <EuroTwoToneIcon />
                    </Tooltip>
                  </Avatar>
                </ListItemAvatar>
              </ListItem>

              {/* Margen */}
              <ListItem
                sx={{
                  width: "100%",
                  minWidth: 0,
                  gridColumn: { xs: "1 / -1", sm: "auto" },
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: alpha(theme.palette.info.main, 0.2),
                  backgroundColor: alpha(theme.palette.info.main, 0.06),
                  px: 1.25,
                  py: 1,
                  gap: 1,
                }}
              >
                <ListItemText
                  sx={{ my: 0, minWidth: 0 }}
                  primary={
                    <Typography sx={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontWeight: 800,
                          fontSize: "14px",
                          color: "#27b4d0",
                        }}
                      >
                        {formatNumber(calculateMarginUn())} |{" "}
                      </span>
                      <span>U</span>
                    </Typography>
                  }
                  secondary={
                    <Typography sx={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontWeight: 800,
                          fontSize: "14px",
                          color: "#27b4d0",
                        }}
                      >
                        {formatNumber(calculateTotalMargin())} |{" "}
                      </span>
                      <span>G</span>
                    </Typography>
                  }
                />
                <ListItemAvatar
                  sx={{
                    ml: 3,
                    "& .MuiAvatar-root": { border: "1px solid #27b4d0" },
                  }}
                >
                  <Avatar
                    sx={{
                      color: "#27b4d0",
                      fontWeight: 800,
                      backgroundColor: theme.palette.background.paper,
                    }}
                  >
                    <Tooltip title="Margin">
                      <ReceiptTwoToneIcon />
                    </Tooltip>
                  </Avatar>
                </ListItemAvatar>
              </ListItem>

              {/* % Margen */}
              <ListItem
                sx={{
                  width: "100%",
                  minWidth: 0,
                  gridColumn: { xs: "1 / -1", sm: "auto" },
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: alpha("#c896ff", 0.35),
                  backgroundColor: alpha("#c896ff", 0.08),
                  px: 1.25,
                  py: 1,
                  gap: 1,
                }}
              >
                <ListItemText
                  sx={{ my: 0, minWidth: 0 }}
                  primary={
                    <Typography sx={{ textAlign: "right" }}>
                      <span style={{ fontWeight: 600, fontSize: "18px" }}>
                        {calculateMarginPercentage()}% |{" "}
                      </span>
                      <span>T</span>
                    </Typography>
                  }
                />
                <ListItemAvatar
                  sx={{
                    ml: 3,
                    "& .MuiAvatar-root": { border: "1px solid #c896ff" },
                  }}
                >
                  <Avatar
                    sx={{
                      color: "#c896ff",
                      fontWeight: 600,
                      backgroundColor: theme.palette.background.paper,
                    }}
                  >
                    <Tooltip title="Total Margin">
                      <BeachAccessIcon />
                    </Tooltip>
                  </Avatar>
                </ListItemAvatar>
              </ListItem>
            </List>
          ) : summaryTab === 1 ? (
            <Box
              sx={{
                py: 1.5,
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                overflowX: "hidden",
                borderRadius: 3,
                border: "1px solid",
                borderColor: alpha(theme.palette.primary.main, 0.08),
                backgroundColor: alpha(theme.palette.common.white, 0.8),
                boxShadow: `0 14px 28px ${alpha(theme.palette.common.black, 0.05)}`,
                px: { xs: 1, md: 1.5 },
                pb: 1.5,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                  alignItems: "center",
                  mb: 1.5,
                }}
              >
                {canOpenA3PedidoFlow ? (
                  <Tooltip
                    title={
                      puedeCrearOEditarPedidoA3
                        ? ""
                        : "No tienes permiso para crear pedidos A3"
                    }
                  >
                    <span>
                      <Button
                        variant="contained"
                        size="small"
                        disabled={!puedeCrearOEditarPedidoA3}
                        onClick={() => {
                          if (!puedeCrearOEditarPedidoA3) return;
                          setPedidoCrmEditando(null);
                          setSelectedArticuloA3(null);
                          setArticuloDialogOpen(true);
                        }}
                        sx={{
                          fontWeight: 700,
                          backgroundColor: "#00c2a3",
                          "&:hover": {
                            backgroundColor: "rgba(0, 194, 163, 0.85)",
                          },
                        }}
                      >
                        Nuevo pedido A3
                      </Button>
                    </span>
                  </Tooltip>
                ) : null}
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => loadA3Pedidos()}
                >
                  Actualizar lista
                </Button>
              </Box>
              {loadingA3Pedidos ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                  <CircularProgress size={28} />
                </Box>
              ) : a3PedidosRows.length === 0 ? (
                <Typography variant="body2" color="text.secondary">
                  Aún no hay pedidos A3 vinculados a este presupuesto.
                </Typography>
              ) : (
                <TableContainer
                  sx={{
                    ...a3PedidosTableContainerSx,
                    borderRadius: 2.5,
                    border: "1px solid",
                    borderColor: alpha(theme.palette.divider, 0.85),
                    backgroundColor: alpha(theme.palette.common.white, 0.92),
                    overflowX: "auto",
                  }}
                >
                  <Table
                    size="small"
                    stickyHeader
                    sx={{ ...a3TableDenseSx, ...a3PedidosTableFixedSx }}
                  >
                    <TableHead
                      sx={{ display: { xs: "none", md: "table-header-group" } }}
                    >
                      <TableRow>
                        <TableCell
                          sx={{
                            width: A3_COL_LINK_ESTIMATES_WIDTH,
                            verticalAlign: "middle",
                            ...a3PedidosCellClipSx,
                          }}
                        >
                          <Stack spacing={0.25}>
                            <Typography
                              variant="caption"
                              sx={{ fontWeight: 700, color: "text.primary" }}
                            >
                              Ref. / artículo
                            </Typography>
                            <Stack
                              direction="row"
                              spacing={0.5}
                              sx={{ flexWrap: "wrap" }}
                            >
                              <Chip
                                size="small"
                                label={`Un estimadas: ${fmtA3Cantidad(unitsResumenCabecera.estimadas)}`}
                                sx={{
                                  bgcolor: "rgba(25, 118, 210, 0.10)",
                                  color: "info.dark",
                                  fontWeight: 700,
                                }}
                              />
                              <Chip
                                size="small"
                                label={`Un pedidas: ${fmtA3Cantidad(unitsResumenCabecera.pedidas)}`}
                                sx={{
                                  bgcolor: "rgba(0, 194, 163, 0.12)",
                                  color: "primary.main",
                                  fontWeight: 700,
                                }}
                              />
                              {unitsResumenCabecera.estimadas > 0 &&
                              unitsResumenCabecera.pedidas >
                                unitsResumenCabecera.estimadas ? (
                                <Chip
                                  size="small"
                                  label={`EXCESO +${fmtA3Cantidad(
                                    unitsResumenCabecera.pedidas -
                                      unitsResumenCabecera.estimadas,
                                  )}`}
                                  sx={{
                                    bgcolor: "#ffebee",
                                    color: "error.dark",
                                    fontWeight: 800,
                                    border: "1px solid",
                                    borderColor: "error.main",
                                  }}
                                />
                              ) : null}
                            </Stack>
                          </Stack>
                        </TableCell>
                        <TableCell
                          sx={{
                            width: A3_COL_COMPRA_WIDTH,
                            borderLeft: "2px solid",
                            borderColor: "error.light",
                            verticalAlign: "top",
                            ...a3PedidosCellClipSx,
                          }}
                        >
                          <Stack spacing={0.35} alignItems="stretch">
                            <Typography
                              variant="caption"
                              sx={{
                                color: "error.main",
                                fontWeight: 800,
                                fontSize: "0.8rem",
                                letterSpacing: 0.3,
                              }}
                            >
                              COMPRA
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{
                                fontSize: "0.76rem",
                                fontWeight: 700,
                                color: "text.primary",
                                lineHeight: 1.25,
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              Σ doc.{" "}
                              {totalesA3PedidosLista.filasConCompra > 0 ? (
                                <Box
                                  component="span"
                                  sx={{
                                    bgcolor: "orange",
                                    color: "#000",
                                    px: 0.45,
                                    /*   py: 0.1, */
                                    borderRadius: 0.5,
                                    fontSize: "1.2rem",
                                  }}
                                >
                                  {fmtA3Importe(
                                    totalesA3PedidosLista.docCompra,
                                  )}
                                </Box>
                              ) : (
                                <Box
                                  component="span"
                                  sx={{ color: "text.disabled" }}
                                >
                                  —
                                </Box>
                              )}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell
                          sx={{
                            width: A3_COL_VENTA_WIDTH,
                            borderLeft: "2px solid",
                            borderColor: "primary.main",
                            verticalAlign: "top",
                            backgroundColor: "#e5f3f2",
                            ...a3PedidosCellClipSx,
                          }}
                        >
                          <Stack spacing={0.35} alignItems="stretch">
                            <Typography
                              variant="caption"
                              sx={{
                                color: "primary.main",
                                fontWeight: 800,
                                fontSize: "0.8rem",
                                letterSpacing: 0.3,
                              }}
                            >
                              VENTA
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{
                                fontSize: "0.76rem",
                                fontWeight: 700,
                                color: "text.primary",
                                lineHeight: 1.25,
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              Σ doc.{" "}
                              {totalesA3PedidosLista.filasConVenta > 0 ? (
                                <Box
                                  component="span"
                                  sx={{
                                    bgcolor: "#00c2a3",
                                    color: "#000",
                                    px: 0.45,
                                    py: 0.1,
                                    borderRadius: 0.5,
                                    fontSize: "1.2rem",
                                  }}
                                >
                                  {fmtA3Importe(totalesA3PedidosLista.docVenta)}
                                </Box>
                              ) : (
                                <Box
                                  component="span"
                                  sx={{ color: "text.disabled" }}
                                >
                                  —
                                </Box>
                              )}
                            </Typography>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {a3PedidosRows.map((row, rowIdx) => {
                        const key = a3PedidoRowReactKey(row, rowIdx);
                        const fmtFechaA3 = (raw) => {
                          if (!raw) return "—";
                          try {
                            return new Date(raw).toLocaleDateString("es-ES");
                          } catch {
                            return "—";
                          }
                        };
                        const fechaCompraStr = fmtFechaA3(
                          row.FechaCompraA3 || row.FechaA3 || row.CreatedAt,
                        );
                        const fechaVentaStr = fmtFechaA3(
                          row.FechaVentaA3 || row.FechaA3 || row.CreatedAt,
                        );
                        const tieneCompra =
                          row?.IdPedc != null && Number(row.IdPedc) > 0;
                        const tieneVenta =
                          row?.IdPedv != null && Number(row.IdPedv) > 0;
                        const proveedorR = formatA3PartyLabel(
                          row.CodPro,
                          row.ProveedorNombre,
                        );
                        const clienteR = formatA3PartyLabel(
                          row.CodCli,
                          row.ClienteNombre,
                        );
                        const pcom =
                          row.SerieCompra != null && row.NumDocCompra != null
                            ? `${String(row.TipoContableCompra || "1").trim()}/${String(row.SerieCompra).trim()}-${row.NumDocCompra}`
                            : "";
                        const pvta =
                          row.SerieVenta != null && row.NumDocVenta != null
                            ? `${String(row.TipoContableVenta || "1").trim()}/${String(row.SerieVenta).trim()}-${row.NumDocVenta}`
                            : "";
                        const estadoCompra = fmtA3Estado(
                          row.EstadoCompra,
                          row.EstadoDetalleCompra,
                        );
                        const estadoVenta = fmtA3Estado(
                          row.EstadoVenta,
                          row.EstadoDetalleVenta,
                        );
                        const bloqueadoBorrado =
                          isA3Served(
                            row?.EstadoCompra,
                            row?.EstadoDetalleCompra,
                          ) ||
                          isA3Served(row?.EstadoVenta, row?.EstadoDetalleVenta);
                        const enviosPedidoCount =
                          Number(
                            enviosCountByPedido?.[
                              Number(row?.IdPresupuestoA3Pedido)
                            ] || 0,
                          ) || 0;
                        const bloqueadoPorLogistica = enviosPedidoCount > 0;
                        const bloqueoDelete =
                          bloqueadoBorrado || bloqueadoPorLogistica;
                        const monedaCompra = etiquetaMonedaResumen(
                          row.MonedaCompraA3 || row.MonedaCoste || "",
                        );
                        const monedaVenta = etiquetaMonedaResumen(
                          row.MonedaVentaA3 || row.MonedaVenta || "",
                        );
                        const refStr =
                          String(row.Referencia || "").trim() || "—";
                        const artStr = String(row.CodArt || "").trim() || "—";
                        const empresaA3 = normalizeEmpresaA3(row.EmpresaA3);
                        const empresaMeta = getEmpresaA3Meta(empresaA3);
                        const empresaBadge = empresaMeta.badge;
                        return (
                          <TableRow
                            key={key}
                            hover
                            sx={{
                              display: { xs: "block", md: "table-row" },
                              border: { xs: "1px solid", md: "none" },
                              borderColor: { xs: "divider", md: "transparent" },
                              borderRadius: { xs: 1, md: 0 },
                              mb: { xs: 1, md: 0 },
                            }}
                          >
                            <TableCell
                              sx={{
                                width: A3_COL_LINK_ESTIMATES_WIDTH,
                                display: { xs: "block", md: "table-cell" },
                                ...a3PedidosCellClipSx,
                                backgroundColor: "#fff",
                              }}
                            >
                              <Stack spacing={0.25}>
                                {canOpenA3PedidoFlow &&
                                puedeCrearOEditarPedidoA3 &&
                                (row?.IdPedc || row?.IdPedv) ? (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      mb: 0.25,
                                    }}
                                  >
                                    <Tooltip
                                      title={`Empresa: ${empresaMeta.label}`}
                                    >
                                      <Box
                                        sx={{
                                          mr: 0.6,
                                          color: empresaMeta.color,
                                          border: empresaMeta.border,
                                          bgcolor: empresaMeta.bgcolor,
                                          height: 32,
                                          width: 32,
                                          borderRadius: 50,
                                          fontSize: "0.8rem",
                                          fontWeight: 700,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {empresaBadge}
                                      </Box>
                                    </Tooltip>
                                    <Tooltip title="Editar importes">
                                      <span>
                                        <IconButton
                                          size="small"
                                          onClick={() => {
                                            setPedidoCrmEditando(row);
                                            setPedidosDialogOpen(true);
                                          }}
                                          sx={{
                                            color: "#00c2a3",
                                            border: "1px solid #00c2a3",
                                          }}
                                        >
                                          <EditIcon fontSize="small" />
                                        </IconButton>
                                      </span>
                                    </Tooltip>
                                    <Tooltip
                                      title={
                                        bloqueadoBorrado
                                          ? "No se puede eliminar: pedido servido en A3"
                                          : bloqueadoPorLogistica
                                            ? `No se puede eliminar: pedido vinculado a ${enviosPedidoCount} envío${enviosPedidoCount === 1 ? "" : "s"}`
                                            : "Eliminar pedido en A3 y CRM"
                                      }
                                    >
                                      <span>
                                        <IconButton
                                          size="small"
                                          onClick={() =>
                                            handleDeleteA3Pedido(row)
                                          }
                                          sx={{
                                            ml: 0.5,
                                            color: "#d32f2f",
                                            border: "1px solid #d32f2f",
                                          }}
                                          disabled={bloqueoDelete}
                                        >
                                          <DeleteOutlineIcon fontSize="small" />
                                        </IconButton>
                                      </span>
                                    </Tooltip>
                                    {tieneVenta &&
                                    row?.IdPresupuestoA3Pedido != null ? (
                                      <Tooltip
                                        title={
                                          enviosPedidoCount > 0
                                            ? `${enviosPedidoCount} envío${enviosPedidoCount === 1 ? "" : "s"} vinculados`
                                            : "Gestionar envíos"
                                        }
                                      >
                                        <Badge
                                          color="primary"
                                          badgeContent={enviosPedidoCount}
                                          invisible={!(enviosPedidoCount > 0)}
                                          sx={{ ml: 0.5 }}
                                        >
                                          <Button
                                            size="small"
                                            variant="outlined"
                                            sx={{ minWidth: 0, px: 1 }}
                                            onClick={() =>
                                              setEnviosDialogRow(row)
                                            }
                                          >
                                            Envíos
                                          </Button>
                                        </Badge>
                                      </Tooltip>
                                    ) : null}
                                  </Box>
                                ) : null}
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontSize: "0.85rem",
                                    display: "block",
                                    wordBreak: "break-word",
                                    color: "orange",
                                    fontWeight: 800,
                                  }}
                                >
                                  {refStr}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  sx={{
                                    fontSize: "0.76rem",
                                    display: "block",
                                    fontWeight: 800,
                                  }}
                                >
                                  {artStr}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell
                              sx={{
                                width: A3_COL_COMPRA_WIDTH,
                                display: { xs: "block", md: "table-cell" },
                                borderLeft: { xs: "none", md: "2px solid" },
                                borderTop: { xs: "2px solid", md: "none" },
                                borderColor: tieneCompra
                                  ? "error.light"
                                  : "divider",
                                bgcolor: tieneCompra
                                  ? "rgba(211, 47, 47, 0.04)"
                                  : "transparent",
                                ...a3PedidosCellClipSx,
                              }}
                            >
                              {tieneCompra ? (
                                <Stack spacing={0.35}>
                                  <Box
                                    component="span"
                                    sx={{
                                      minWidth: 80,
                                      maxWidth: 80,
                                      textAlign: "center",
                                      fontSize: "0.72rem",
                                      fontWeight: 700,
                                      color: "text.secondary",
                                      bgcolor: "rgba(0,0,0,0.04)",
                                      border: "1px solid",
                                      borderColor: "divider",
                                      borderRadius: 0.5,
                                      px: 0.5,
                                      py: 0.05,
                                      mr: 1.2,
                                    }}
                                  >
                                    {fechaCompraStr}
                                  </Box>
                                  <Box
                                    display="flex"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    sx={{ flexWrap: "wrap", rowGap: 0.6 }}
                                  >
                                    {estadoCompra ? (
                                      <Box
                                        component="span"
                                        sx={{
                                          ...a3EstadoBadgeSx(
                                            row.EstadoCompra,
                                            row.EstadoDetalleCompra,
                                          ),
                                          height: 24,
                                          width: 24,
                                          alignItems: "center",
                                          display: "flex",
                                          justifyContent: "center",
                                          borderRadius: 50,
                                          fontSize: "0.8rem",
                                          fontWeight: 700,
                                          mr: 1,
                                        }}
                                      >
                                        {estadoCompra}
                                      </Box>
                                    ) : null}
                                    <Typography
                                      variant="caption"
                                      sx={{
                                        fontWeight: 700,
                                        fontSize: "0.8rem",
                                        display: "block",
                                        mr: 2,
                                        color: "#fff",
                                        backgroundColor: "error.light",
                                        px: 0.45,
                                        py: 0.1,
                                        borderRadius: 0.5,
                                      }}
                                    >
                                      {pcom || "—"}
                                    </Typography>
                                    <PedidoCompraPrint row={row} />
                                    {monedaCompra ? (
                                      <Box
                                        component="span"
                                        sx={{
                                          bgcolor: "error.main",
                                          color: "#fff",
                                          height: 24,
                                          width: 24,
                                          alignItems: "center",
                                          display: "flex",
                                          justifyContent: "center",
                                          borderRadius: 50,
                                          fontSize: "0.9rem",
                                          fontWeight: 700,
                                          mr: 1,
                                        }}
                                      >
                                        {monedaCompra}
                                      </Box>
                                    ) : null}
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                      sx={{
                                        fontSize: "0.76rem",
                                        display: "block",
                                        wordBreak: "break-word",
                                        fontWeight: 800,
                                      }}
                                    >
                                      {truncA3(proveedorR, 35)}
                                    </Typography>
                                  </Box>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{
                                      fontSize: "0.73rem",
                                      display: "block",
                                    }}
                                  >
                                    Un: {fmtA3Cantidad(row.UnidadesCompra)} ×{" "}
                                    {fmtA3Importe(
                                      resolveUnitPriceStable(
                                        row.UnidadesCompra,
                                        row.PrecioCosteUn,
                                        row.TotalDocumentoCompra,
                                        row.TotalCompra,
                                      ),
                                    )}{" "}
                                    →{" "}
                                    <strong>
                                      {fmtA3Importe(row.TotalCompra)}
                                    </strong>{" "}
                                    · IVA {fmtA3PorcIva(row.PorIvaCompra)}{" "}
                                    {fmtA3Importe(row.CuotaIvaCompra)} · Total{" "}
                                    <Box
                                      component="span"
                                      sx={{
                                        bgcolor: "error.main",
                                        color: "common.white",
                                        fontWeight: 700,
                                        px: 0.45,
                                        py: 0.15,
                                        borderRadius: 0.5,
                                        display: "inline-block",
                                      }}
                                    >
                                      {fmtA3Importe(row.TotalDocumentoCompra)}
                                    </Box>
                                  </Typography>
                                </Stack>
                              ) : null}
                            </TableCell>
                            <TableCell
                              sx={{
                                width: A3_COL_VENTA_WIDTH,
                                display: { xs: "block", md: "table-cell" },
                                borderLeft: { xs: "none", md: "2px solid" },
                                borderTop: { xs: "2px solid", md: "none" },
                                borderColor: tieneVenta
                                  ? "primary.main"
                                  : "divider",
                                bgcolor: tieneVenta
                                  ? "rgba(0, 194, 163, 0.06)"
                                  : "transparent",
                                ...a3PedidosCellClipSx,
                              }}
                            >
                              {tieneVenta ? (
                                <Stack spacing={0.35}>
                                  <Box
                                    component="span"
                                    sx={{
                                      minWidth: 80,
                                      maxWidth: 80,
                                      textAlign: "center",
                                      fontSize: "0.72rem",
                                      fontWeight: 700,
                                      color: "text.secondary",
                                      bgcolor: "rgba(0,0,0,0.04)",
                                      border: "1px solid",
                                      borderColor: "divider",
                                      borderRadius: 0.5,
                                      px: 0.5,
                                      py: 0.05,
                                      mr: 1.2,
                                    }}
                                  >
                                    {fechaVentaStr}
                                  </Box>
                                  <Box
                                    display="flex"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    sx={{ flexWrap: "wrap", rowGap: 0.6 }}
                                  >
                                    {estadoVenta ? (
                                      <Box
                                        component="span"
                                        sx={{
                                          ...a3EstadoBadgeSx(
                                            row.EstadoVenta,
                                            row.EstadoDetalleVenta,
                                          ),
                                          height: 24,
                                          width: 24,
                                          alignItems: "center",
                                          display: "flex",
                                          justifyContent: "center",
                                          borderRadius: 50,
                                          fontSize: "0.8rem",
                                          fontWeight: 700,
                                          mr: 1,
                                        }}
                                      >
                                        {estadoVenta}
                                      </Box>
                                    ) : null}
                                    <Typography
                                      variant="caption"
                                      sx={{
                                        fontWeight: 700,
                                        fontSize: "0.8rem",
                                        display: "block",
                                        color: "#fff",
                                        mr: 2,
                                        backgroundColor: "primary.light",
                                        px: 0.45,
                                        py: 0.1,
                                        borderRadius: 0.5,
                                      }}
                                    >
                                      {pvta || "—"}
                                    </Typography>
                                    {monedaVenta ? (
                                      <Box
                                        component="span"
                                        sx={{
                                          bgcolor: "primary.main",
                                          color: "#fff",
                                          height: 24,
                                          width: 24,
                                          alignItems: "center",
                                          display: "flex",
                                          justifyContent: "center",
                                          borderRadius: 50,
                                          fontSize: "0.9rem",
                                          fontWeight: 700,
                                          mr: 1,
                                        }}
                                      >
                                        {monedaVenta}
                                      </Box>
                                    ) : null}
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                      sx={{
                                        fontSize: "0.76rem",
                                        display: "block",
                                        wordBreak: "break-word",
                                        fontWeight: 800,
                                      }}
                                    >
                                      {truncA3(clienteR, 35)}
                                    </Typography>
                                  </Box>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{
                                      fontSize: "0.73rem",
                                      display: "block",
                                    }}
                                  >
                                    Un: {fmtA3Cantidad(row.UnidadesVenta)} ×{" "}
                                    {fmtA3Importe(
                                      resolveUnitPriceStable(
                                        row.UnidadesVenta,
                                        row.PrecioVentaUn,
                                        row.TotalDocumentoVenta,
                                        row.TotalVenta,
                                      ),
                                    )}{" "}
                                    →{" "}
                                    <strong>
                                      {fmtA3Importe(row.TotalVenta)}
                                    </strong>{" "}
                                    · IVA {fmtA3PorcIva(row.PorIvaVenta)} ·
                                    cuota {fmtA3Importe(row.CuotaIvaVenta)} ·
                                    doc{" "}
                                    <Box
                                      component="span"
                                      sx={{
                                        bgcolor: "#00c2a3",
                                        color: "#fff",
                                        fontWeight: 800,
                                        px: 0.45,
                                        py: 0.15,
                                        borderRadius: 0.5,
                                        display: "inline-block",
                                      }}
                                    >
                                      {fmtA3Importe(row.TotalDocumentoVenta)}
                                    </Box>
                                  </Typography>
                                </Stack>
                              ) : null}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>
          ) : summaryTab === 2 ? (
            <EstimateComunicacionesPanel
              theme={theme}
              presupuesto={newPresupuesto}
              proveedores={proveedores}
              lines={lines}
              party="supplier"
              onCostApplied={async () => {
                if (typeof setRefreshKey === "function") {
                  setRefreshKey((k) => k + 1);
                }
                const id =
                  budget?.IdPresupuesto || newPresupuesto?.IdPresupuesto;
                if (id && typeof setLines === "function") {
                  try {
                    const loaded = await fetchBudgetLines(id);
                    if (Array.isArray(loaded)) setLines(loaded);
                  } catch (err) {
                    console.warn(
                      "[comms] refresh lines after apply-cost:",
                      err?.message || err,
                    );
                  }
                }
              }}
            />
          ) : (
            <EstimateComunicacionesPanel
              theme={theme}
              presupuesto={newPresupuesto}
              proveedores={proveedores}
              lines={lines}
              party="client"
              precioUnitario={calculateSellingPriceUN?.()}
              totalVenta={calculateTotalSellingPrice?.()}
              moneda={
                (Array.isArray(lines) &&
                  lines.find((l) => l?.MonedaVenta)?.MonedaVenta) ||
                "USD"
              }
              onClientOfferSent={(result) => {
                const patch = result?.presupuesto;
                if (typeof setNewPresupuesto === "function") {
                  const fechaPresentacion = patch?.FechaPresentacion
                    ? formatDateForDisplay(patch.FechaPresentacion) ||
                      patch.FechaPresentacion
                    : null;
                  setNewPresupuesto((prev) => ({
                    ...prev,
                    ...(patch?.Estado
                      ? {
                          Estado: patch.Estado,
                          FechaPresentacion:
                            fechaPresentacion || prev.FechaPresentacion,
                        }
                      : {}),
                    ...(result?.tommyNoEmail
                      ? {}
                      : {
                          ClientOfferCount:
                            (Number(prev.ClientOfferCount) || 0) + 1,
                          HasComms: true,
                        }),
                  }));
                }
                if (typeof setRefreshKey === "function") {
                  setRefreshKey((k) => k + 1);
                }
              }}
            />
          )}
        </CardContent>
      )}

      <Dialog
        open={deleteA3DialogOpen}
        onClose={closeDeleteA3Dialog}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Eliminar pedido A3</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Se eliminara el pedido en A3 y despues el vinculo en CRM. Esta
            accion no se puede deshacer.
          </DialogContentText>
          {deleteA3DialogError ? (
            <Alert severity="error" sx={{ mt: 1.5 }}>
              {deleteA3DialogError}
            </Alert>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeDeleteA3Dialog}
            disabled={deleteA3DialogLoading}
          >
            Cancelar
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={confirmDeleteA3Pedido}
            disabled={deleteA3DialogLoading}
          >
            {deleteA3DialogLoading ? "Eliminando..." : "Eliminar"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={unitsLimitDialogOpen}
        onClose={() => {
          setUnitsLimitDialogOpen(false);
          setPendingOverUnitsCreate(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Unidades presupuestadas superadas</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {unitsLimitDialogMessage ||
              "No se puede continuar porque el acumulado del artículo supera las units del estimate."}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setUnitsLimitDialogOpen(false);
              setPendingOverUnitsCreate(null);
            }}
            variant="outlined"
            color="inherit"
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="warning"
            onClick={async () => {
              try {
                if (pendingOverUnitsCreate) {
                  await executeCreatePedido(pendingOverUnitsCreate);
                }
              } finally {
                setUnitsLimitDialogOpen(false);
                setPendingOverUnitsCreate(null);
              }
            }}
          >
            Continuar igualmente
          </Button>
        </DialogActions>
      </Dialog>

      {/* Líneas */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "Column",
          marginTop: { xs: "1em", sm: "0em", md: "0px", lg: "0px" },
          minWidth: 0,
        }}
      >
        {budget?.IdPresupuesto && (
          <Box
            sx={{
              borderRadius: 3,
              border: "1px solid",
              borderColor: alpha(theme.palette.primary.main, 0.16),
              backgroundColor: theme.palette.background.paper,
              boxShadow: `0 12px 28px ${alpha(theme.palette.common.black, 0.07)}`,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                px: { xs: 1.25, md: 1.75 },
                py: 1.25,
                borderBottom: "1px solid",
                borderColor: alpha(theme.palette.divider, 0.18),
                backgroundColor: alpha(theme.palette.primary.main, 0.04),
              }}
            >
              {/* <Typography
                variant="overline"
                sx={{
                  color: "text.secondary",
                  display: "block",
                  fontWeight: 800,
                  letterSpacing: 0.8,
                }}
              >
                Estimate Lines
              </Typography> */}
              <Typography
                sx={{
                  fontSize: { xs: "1rem", md: "1.08rem" },
                  fontWeight: 800,
                  color: "primary.dark",
                }}
              >
                Budget lines
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                overflowX: "auto",
                px: { xs: 0.5 /*  md: 1  */ },
                pb: 1,
              }}
            >
              <EstimatesLineas
                presupuesto={newPresupuesto}
                presupuestoId={budget.IdPresupuesto}
                escandalloGrupos={escandalloGrupos}
                escandalloSubgrupos={escandalloSubgrupos}
                materialSubgrupos={materialSubgrupos}
                defaultSupplier={newPresupuesto.IdProveedor}
                initialLines={lines}
                refreshKey={refreshKey}
                onSave={setLines}
                isLocked={newPresupuesto.Estado !== "Created"}
              />
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default CardDerechaBolas;
